<div class="exhaust-container">
    <div
        #cylinder
        style="padding-top: 24px; padding-left: 24px"
        *ngIf="cylinderChannels.length > 0"
    >
        <app-cylinder-temperature
            *ngIf="cylinderChannels.length > 0"
            [temperatures]="cylinderChannels"
            [title]="title"
        ></app-cylinder-temperature>
    </div>
    <div
        #deviation
        style="padding-top: 24px; padding-left: 24px"
        *ngIf="deviationChannels.length > 0"
    >
        <app-cylinder-deviation
            *ngIf="deviationChannels.length > 0"
            [devaitons]="deviationChannels"
            [deviationLimit]="graph.deviationLimit"
            [averageChannel]="channels[graph.averageChannel]"
            [averageChannelValue]="averageChannel"
            [title]="title"
        ></app-cylinder-deviation>
    </div>
    <div
        #turbo
        style="padding-top: 24px; padding-left: 24px"
        *ngIf="turboChannels.length > 0"
    >
        <app-turbo-charger
            *ngIf="turboChannels.length > 0"
            [temperatures]="turboChannels"
            [title]="title"
        ></app-turbo-charger>
    </div>
</div>
